import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from "../../hooks/hook";
import styles from './HomePage.module.scss';
import BlockControl from "./BlockControl";
import UserManagementMenu from "./UserManagementMenu";
const ChatMenu = ({ selectedChat }) => {
    const showCheckbox = useAppSelector(state => state.app.showCheckbox);
    return (_jsx("div", { className: styles.menu, children: showCheckbox ?
            _jsx(BlockControl, {})
            :
                _jsx("div", { className: styles.menu__wrapper, children: _jsx(UserManagementMenu, { chatInfo: selectedChat }) }) }));
};
export default ChatMenu;
